// src/pagination/PaginationTable.js
import React from 'react';
import TablePagination from '@mui/material/TablePagination';

const Pagination4= ({ count, rowsPerPage, page, onPageChange, onRowsPerPageChange }) => {
  const handleRowsPerPageChange = (event) => {
    const value = event.target.value;
    onRowsPerPageChange(value === 'all' ? count : parseInt(value, 10));
  };

  return (
    <TablePagination
      rowsPerPageOptions={[ 10, 25, 50,100, { label: 'All', value: 'all' }]} // Added 'All' option
      component="div"
      count={count}
      rowsPerPage={rowsPerPage}
      page={page}
      onPageChange={onPageChange}
      onRowsPerPageChange={handleRowsPerPageChange}
    />
  );
};

export default Pagination4;
